var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbotSelections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 144.027,
    height: 152.433,
    viewBox: "0 0 144.027 152.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abc1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8c5e7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_380"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.631,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.746,
    cy: 0.366,
    r: 1.001,
    gradientTransform: "matrix(-0.664, 0.748, -0.847, -0.752, 1.551, 0.083)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#c4d9f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cade5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_371",
    x: 45.556,
    y: 53.058,
    width: 39.922,
    height: 31.635,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_372",
    x: 83.182,
    y: 50.831,
    width: 39.922,
    height: 31.635,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.921,
    y1: 0.127,
    x2: 0.137,
    y2: 0.816,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#072046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08142f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#739bd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88a8d1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.674,
    cy: 0.537,
    r: 0.634,
    gradientTransform: "matrix(0.657, -0.754, 0.413, 0.36, -0.035, 0.697)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#eaf3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#d6e6f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4c7f0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_379"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.631,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.919,
    y1: 0.392,
    x2: 0.353,
    y2: 0.885,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#de3637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d23633"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_427",
    x: 67.999,
    y: 121.019,
    width: 20.753,
    height: 29.617,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#462626",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_427-2",
    x: 67.999,
    y: 121.019,
    width: 20.753,
    height: 29.617,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#af0d1e",
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.905,
    y1: 0.657,
    x2: 0.13,
    y2: 0.602,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa343f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c40c1b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_426",
    x: 70.354,
    y: 111.451,
    width: 17.192,
    height: 12.13,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_426-2",
    x: 70.354,
    y: 111.451,
    width: 17.192,
    height: 12.13,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f0a0a",
    floodOpacity: 0.62,
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.475,
    y1: -0.025,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8bcd3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.768,
    cy: 0.311,
    r: 0.951,
    gradientTransform: "matrix(-0.907, 0.42, -0.531, -1.147, 1.585, 0.217)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#e4edf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#c4d7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7aa5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ba6db"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_374"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.561,
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.21,
    cy: 0.622,
    r: 0.587,
    gradientTransform: "matrix(0.583, 0.812, -1.056, 0.758, 0.745, -0.02)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ba6d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b4f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242c3e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_21"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451,
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_26"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451,
    result: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.67,
    y1: 0.97,
    x2: 0.284,
    y2: 0.039,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#fab22b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_289",
    x: 5.218,
    y: 67.844,
    width: 17.521,
    height: 23.213,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb109",
    floodOpacity: 0.51
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.67,
    y1: 0.97,
    x2: 0.284,
    y2: 0.039,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabb33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_290",
    x: 5.952,
    y: 67.129,
    width: 19.818,
    height: 24.091,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb109",
    floodOpacity: 0.51
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.921,
    y1: 0.127,
    x2: 0.137,
    y2: 0.816,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#192c49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08142f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_369",
    x: 23.465,
    y: 6.459,
    width: 116.379,
    height: 101.255,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.651
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_369-2",
    x: 23.465,
    y: 6.459,
    width: 116.379,
    height: 101.255,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#123c67",
    result: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.86,
    y1: 0.329,
    x2: 0.744,
    y2: 0.916,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6382a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101f3b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_373",
    x: 69.383,
    y: 62.432,
    width: 36.245,
    height: 29.013,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7fc1fa"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_433",
    x: 45.985,
    y: 52.299,
    width: 41.786,
    height: 34.897,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_434",
    x: 82.799,
    y: 44.213,
    width: 41.786,
    height: 34.897,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.722,
    cy: 0.228,
    r: 0.788,
    gradientTransform: "matrix(0.718, 0.696, -0.489, 0.504, 0.253, -0.42)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99d18"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_430",
    x: 62.953,
    y: 0,
    width: 38.268,
    height: 37.767,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#be6c1b",
    result: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(9585.941 -2606.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(-9545.202 2630.526)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380-2",
    "data-name": "Path 380",
    d: "M.552,2.941C2.02-.09,8.2-1.221,13.062,1.69s9.143,9.72,5.87,12.318-9.31-.144-13.858-2.791S-.916,5.973.552,2.941Z",
    transform: "translate(43.727 102.102) rotate(-43)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -40.74, -24.25)",
    filter: "url(#Path_380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380-3",
    "data-name": "Path 380",
    d: "M.552,2.941C2.02-.09,8.2-1.221,13.062,1.69s9.143,9.72,5.87,12.318-9.31-.144-13.858-2.791S-.916,5.973.552,2.941Z",
    transform: "translate(84.47 126.35) rotate(-43)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M6.7,1.087c1.385-1.828,4.849-7.7,17.257-7.7S44.467-4.78,47.68-.5s.472,19.373,0,22.25-4.31,7.213-9.129,8.463c-4.354,1.13-9.762,2.673-17.425.885S10.372,26.523,7.9,23.061,5.313,2.915,6.7,1.087Z",
    transform: "translate(6.985 96.271)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 14.817,
    cy: 2.819,
    rx: 14.817,
    ry: 2.819,
    transform: "translate(19.223 90.111) rotate(1)",
    fill: "#466ea4",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -40.74, -24.25)",
    filter: "url(#Path_371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371-2",
    "data-name": "Path 371",
    d: "M-9203.837,2745.306s-.438-8.761,8.471-9.491,9.344,8.031,9.344,8.031",
    transform: "translate(9260.4 -2671.71)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -40.74, -24.25)",
    filter: "url(#Path_372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372-2",
    "data-name": "Path 372",
    d: "M-9203.837,2745.306s-.438-8.761,8.471-9.491,9.344,8.031,9.344,8.031",
    transform: "translate(9298.03 -2673.94)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M.641,77.627H0c7.116-.029,17.331-.572,25.581-3.01,7.373-2.178,10.849-3.592,13.775-5.6l.037-.026a24.917,24.917,0,0,0,7.38-7.087c4.16-5.826,6.359-13.3,6.359-21.613v-4.96c0-9.861-5.924-18.123-9.456-22.171a26.535,26.535,0,0,0-7.754-6.111l-.335-.19A53.019,53.019,0,0,0,25.581,2.4C21.4.97,14.42.052,7.367,0l.147,0h.465C15.259,0,22.473.919,26.8,2.4A53.065,53.065,0,0,1,36.811,6.856l.333.189A26.539,26.539,0,0,1,44.9,13.157a42.536,42.536,0,0,1,6.581,9.971,28.906,28.906,0,0,1,2.875,12.2v4.96c0,8.314-2.2,15.788-6.358,21.613a24.917,24.917,0,0,1-7.376,7.084l-.041.028c-2.926,2.011-6.4,3.425-13.775,5.6a74.131,74.131,0,0,1-13.921,2.47C8.071,77.533,3.569,77.627.641,77.627Z",
    transform: "translate(32.492 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 4.295,
    cy: 7.635,
    rx: 4.295,
    ry: 7.635,
    transform: "translate(14.551 95.778) rotate(21)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379-2",
    "data-name": "Path 379",
    d: "M19.528,2.941C18.059-.09,11.877-1.221,7.018,1.69s-9.143,9.72-5.87,12.318,9.31-.144,13.858-2.791S21,5.973,19.528,2.941Z",
    transform: "translate(0 99.059) rotate(-17)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -40.74, -24.25)",
    filter: "url(#Path_379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379-3",
    "data-name": "Path 379",
    d: "M19.528,2.941C18.059-.09,11.877-1.221,7.018,1.69s-9.143,9.72-5.87,12.318,9.31-.144,13.858-2.791S21,5.973,19.528,2.941Z",
    transform: "translate(40.74 123.31) rotate(-17)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(29.76 88.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004-2",
    "data-name": "Group 1004",
    transform: "translate(0 8.568)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -70.5, -121.52)",
    filter: "url(#Path_427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427-3",
    "data-name": "Path 427",
    d: "M-10829.08,1798.944s-.856,3.929-2.076,8.264-2.8,9.077-2.8,9.077,2.117,2.763,4.336,5.082a54.9,54.9,0,0,0,4.54,4.194s2.668-2.239,4.887-4.558a54.829,54.829,0,0,0,3.99-4.718,47.937,47.937,0,0,0-1.706-9.077,44.536,44.536,0,0,0-3.652-8.264h-7.516Z",
    transform: "translate(10904.46 -1677.43)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -70.5, -121.52)",
    filter: "url(#Path_427-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427-4",
    "data-name": "Path 427",
    d: "M-10829.08,1798.944s-.856,3.929-2.076,8.264-2.8,9.077-2.8,9.077,2.117,2.763,4.336,5.082a54.9,54.9,0,0,0,4.54,4.194s2.668-2.239,4.887-4.558a54.829,54.829,0,0,0,3.99-4.718,47.937,47.937,0,0,0-1.706-9.077,44.536,44.536,0,0,0-3.652-8.264h-7.516Z",
    transform: "translate(10904.46 -1677.43)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(1.355)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -71.85, -112.95)",
    filter: "url(#Path_426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426-3",
    "data-name": "Path 426",
    d: "M-10827.248,1767.434l11.667-.293a1.134,1.134,0,0,1,.61.507,1.649,1.649,0,0,1,0,.9,29.517,29.517,0,0,1-.909,3.592,28.729,28.729,0,0,1-1.411,3.394,1.124,1.124,0,0,1-.36.475,1.993,1.993,0,0,1-.66.266h-6.181a2.445,2.445,0,0,1-1.11-.266,2.046,2.046,0,0,1-.693-.827l-2.615-5.665s-.415-1.192,0-1.712S-10827.248,1767.434-10827.248,1767.434Z",
    transform: "translate(10900.95 -1654.19)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -71.85, -112.95)",
    filter: "url(#Path_426-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426-4",
    "data-name": "Path 426",
    d: "M-10827.248,1767.434l11.667-.293a1.134,1.134,0,0,1,.61.507,1.649,1.649,0,0,1,0,.9,29.517,29.517,0,0,1-.909,3.592,28.729,28.729,0,0,1-1.411,3.394,1.124,1.124,0,0,1-.36.475,1.993,1.993,0,0,1-.66.266h-6.181a2.445,2.445,0,0,1-1.11-.266,2.046,2.046,0,0,1-.693-.827l-2.615-5.665s-.415-1.192,0-1.712S-10827.248,1767.434-10827.248,1767.434Z",
    transform: "translate(10900.95 -1654.19)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(-9593.136 2622.633) rotate(-9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 7.635,
    cy: 17.18,
    rx: 7.635,
    ry: 17.18,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 123.268, 36.706)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374-2",
    "data-name": "Path 374",
    d: "M32.819,104.37s34.885,6.131,54.97,0,39.326-16.438,38.9-37.844-.159-43.923-20.932-56.45S67.439-1.606,43.179,3.521,6.6,29.315,6.6,29.315-4.812,47.5,2.375,74.559,23.3,100.987,32.819,104.37",
    transform: "translate(8.636 5.12)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 9.66, -15.03)",
    filter: "url(#Path_374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374-3",
    "data-name": "Path 374",
    d: "M32.819,104.37s34.885,6.131,54.97,0,39.326-16.438,38.9-37.844-.159-43.923-20.932-56.45S67.439-1.606,43.179,3.521,6.6,29.315,6.6,29.315-4.812,47.5,2.375,74.559,23.3,100.987,32.819,104.37",
    transform: "translate(2.14 20.06) rotate(-9)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(30.455 85.133) rotate(175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 13.464,
    cy: 20.822,
    rx: 13.464,
    ry: 20.822,
    transform: "translate(0 0)",
    fill: "#6493bb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 13.307,
    cy: 20.509,
    rx: 13.307,
    ry: 20.509,
    transform: "translate(0.313 0.313)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21-2",
    "data-name": "Ellipse 21",
    cx: 10.358,
    cy: 17.691,
    rx: 10.358,
    ry: 17.691,
    transform: "translate(5.273 2.818)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97, -0.24, 0.24, -0.97, 11.98, 101.59)",
    filter: "url(#Ellipse_21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21-3",
    "data-name": "Ellipse 21",
    cx: 10.358,
    cy: 17.691,
    rx: 10.358,
    ry: 17.691,
    transform: "translate(30.4 94.22) rotate(166)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7-2",
    "data-name": "Subtraction 7",
    d: "M.783,0A7.145,7.145,0,0,0,0,.043C2.8.353,5.405,2.326,7.332,5.6a24.181,24.181,0,0,1,3,12.091,24.181,24.181,0,0,1-3,12.091C5.405,33.055,2.8,35.029,0,35.339a7.145,7.145,0,0,0,.783.043,7.666,7.666,0,0,0,4.327-1.39A12.512,12.512,0,0,0,8.643,30.2a20.393,20.393,0,0,0,2.382-5.623,26.827,26.827,0,0,0,.873-6.886,26.827,26.827,0,0,0-.873-6.886A20.393,20.393,0,0,0,8.643,5.182,12.512,12.512,0,0,0,5.11,1.39,7.666,7.666,0,0,0,.783,0Z",
    transform: "translate(14.09 2.818)",
    fill: "#5e6b84",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26-2",
    "data-name": "Ellipse 26",
    cx: 10.358,
    cy: 17.691,
    rx: 10.358,
    ry: 17.691,
    transform: "translate(5.273 2.818)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97, -0.24, 0.24, -0.97, 11.98, 101.59)",
    filter: "url(#Ellipse_26)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26-3",
    "data-name": "Ellipse 26",
    cx: 10.358,
    cy: 17.691,
    rx: 10.358,
    ry: 17.691,
    transform: "translate(30.4 94.22) rotate(166)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 10.513, 13.361)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.95, -0.33, 0.33, -0.95, -6.23, 88.02)",
    filter: "url(#Path_289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289-2",
    "data-name": "Path 289",
    d: "M6.572,0A4.069,4.069,0,0,0,5.536.85,8.318,8.318,0,0,0,4.387,2.607a28.753,28.753,0,0,1,.233,5.184,27.617,27.617,0,0,1-.855,5.055s-1.385-.007-2.52-.055A1.643,1.643,0,0,1,.37,11.382a5.257,5.257,0,0,0-.342,1.409,4.671,4.671,0,0,0,.1,1.606,1.769,1.769,0,0,0,1.122,1.351l4.206.147A55.841,55.841,0,0,0,6.592,8.217,67.461,67.461,0,0,0,6.572,0Z",
    transform: "translate(19.74 85.87) rotate(161)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.95, -0.33, 0.33, -0.95, -6.23, 88.02)",
    filter: "url(#Path_290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290-2",
    "data-name": "Path 290",
    d: "M9.106,0A4.272,4.272,0,0,0,7.645,1.155,8.578,8.578,0,0,0,6.556,3.191H3.537a2.828,2.828,0,0,0-1.111,1.97,2.434,2.434,0,0,0,.784,1.907l2.626.019a4.9,4.9,0,0,1,.118,1.472,3.767,3.767,0,0,1-.424,1.294L3.68,9.834a6.364,6.364,0,0,0-1.254,2.935A4.063,4.063,0,0,0,3.089,16,3.736,3.736,0,0,1,.948,14.8a4.306,4.306,0,0,1-.592-2.423,6.448,6.448,0,0,1,.42-2.146,4.443,4.443,0,0,1,1-1.55A4.186,4.186,0,0,1,.425,7.255,3.79,3.79,0,0,1,.005,5.226,7.114,7.114,0,0,1,1.164,1.863,4.554,4.554,0,0,1,3.537.253Z",
    transform: "translate(22.77 85.26) rotate(161)",
    fill: "url(#linear-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(30.455 19.694)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, -20.79, -34.72)",
    filter: "url(#Path_369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369-3",
    "data-name": "Path 369",
    d: "M37.222,1.093C48.009-.964,62.187.115,68.871,2.4A52.9,52.9,0,0,1,78.879,6.857a27.238,27.238,0,0,1,8.088,6.3c4.941,5.663,9.456,13.537,9.456,22.171v4.96c0,7.791-1.933,15.415-6.358,21.613a25.105,25.105,0,0,1-7.417,7.112c-2.775,1.907-6.087,3.332-13.776,5.6-13.21,3.9-31.649,2.894-31.649,2.894-8.881,0-17.979-2.091-24.594-7.458C4.432,63.4,0,51.964,0,40.288V37.424c0-13.3,4.346-22.267,15.074-29C20.564,4.984,26.436,3.15,37.222,1.093Z",
    transform: "translate(25.97 31.04) rotate(-9)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, -20.79, -34.72)",
    filter: "url(#Path_369-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369-4",
    "data-name": "Path 369",
    d: "M37.222,1.093C48.009-.964,62.187.115,68.871,2.4A52.9,52.9,0,0,1,78.879,6.857a27.238,27.238,0,0,1,8.088,6.3c4.941,5.663,9.456,13.537,9.456,22.171v4.96c0,7.791-1.933,15.415-6.358,21.613a25.105,25.105,0,0,1-7.417,7.112c-2.775,1.907-6.087,3.332-13.776,5.6-13.21,3.9-31.649,2.894-31.649,2.894-8.881,0-17.979-2.091-24.594-7.458C4.432,63.4,0,51.964,0,40.288V37.424c0-13.3,4.346-22.267,15.074-29C20.564,4.984,26.436,3.15,37.222,1.093Z",
    transform: "translate(25.97 31.04) rotate(-9)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M68.1,28.209s-.977-4.889-2.4-9.494-2.079-6.6-7.01-10.6S47.767,1.269,36.028.169,11.737,3.716,11.737,3.716L0,9.422l15.813,6.847,20.215-1.754S47.847,17,52.941,17.286s4.606-.528,7.214,2.569S68.1,28.209,68.1,28.209Z",
    transform: "translate(22.607 3.584)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, -20.79, -34.72)",
    filter: "url(#Path_373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373-2",
    "data-name": "Path 373",
    d: "M0,1.022A6.943,6.943,0,0,0,7.788,5.315C13.774,4.439,13.726,0,13.726,0",
    transform: "translate(80.51 75.31) rotate(-9)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, -20.79, -34.72)",
    filter: "url(#Path_433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433-2",
    "data-name": "Path 433",
    d: "M0,9.535S-.436.774,8.473.043s9.344,8.031,9.344,8.031",
    transform: "translate(57.28 66.39) rotate(-9)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, -20.79, -34.72)",
    filter: "url(#Path_434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434-2",
    "data-name": "Path 434",
    d: "M0,9.535S-.436.774,8.473.043s9.344,8.031,9.344,8.031",
    transform: "translate(94.1 58.31) rotate(-9)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430-2",
    "data-name": "Path 430",
    d: "M2.821,4.607c-3.763,4.012-3.763,10.431,0,13.44s10.631-6.82,15.044,0-3.812,11.233-6.419,14.442C14.255,34.9,33.159,27.023,33.51,18.046S29.45,3.3,21.878,1,6.581.595,2.821,4.607Z",
    transform: "translate(71.023 0)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 9.66, -15.03)",
    filter: "url(#Path_430)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430-3",
    "data-name": "Path 430",
    d: "M2.821,4.607c-3.763,4.012-3.763,10.431,0,13.44s10.631-6.82,15.044,0-3.812,11.233-6.419,14.442C14.255,34.9,33.159,27.023,33.51,18.046S29.45,3.3,21.878,1,6.581.595,2.821,4.607Z",
    transform: "translate(62.95 5.25) rotate(-9)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbotSelections);
export default __webpack_public_path__ + "static/media/BBOT-selections.e77127152651d257ab5f5b92ddd9aa8d.svg";
export { ForwardRef as ReactComponent };